import React, { useState } from 'react';

interface DateSelectionModalProps {
  isOpen: boolean;
  onClose: () => void;
  onDateChange: (startDate: string, endDate: string) => void;
  currentStartDate: string;
  currentEndDate: string;
}

const DateSelectionModal: React.FC<DateSelectionModalProps> = ({
  isOpen,
  onClose,
  onDateChange,
  currentStartDate,
  currentEndDate
}) => {
  const [startDate, setStartDate] = useState(currentStartDate);
  const [endDate, setEndDate] = useState(currentEndDate);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    // Ensure dates are sent as UTC to prevent timezone issues
    // Convert the selected dates to UTC midnight to avoid date shifting
    const startDateUTC = new Date(startDate + 'T00:00:00Z').toISOString().split('T')[0];
    const endDateUTC = new Date(endDate + 'T00:00:00Z').toISOString().split('T')[0];
    
    onDateChange(startDateUTC, endDateUTC);
    onClose();
  };

  const handleCancel = () => {
    setStartDate(currentStartDate);
    setEndDate(currentEndDate);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl p-6 w-full max-w-md">
        <h3 className="text-[20px] leading-7 font-medium text-gray-800 mb-4">Select Date Range</h3>
        
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="startDate" className="block text-[16px] leading-6 text-gray-700 mb-2">
              Start Date
            </label>
            <input
              type="date"
              id="startDate"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none text-[16px]"
              required
            />
          </div>
          
          <div>
            <label htmlFor="endDate" className="block text-[16px] leading-6 text-gray-700 mb-2">
              End Date
            </label>
            <input
              type="date"
              id="endDate"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none text-[16px]"
              required
            />
          </div>
          
          <div className="flex space-x-3 pt-4">
            <button
              type="button"
              onClick={handleCancel}
              className="flex-1 py-2 px-4 border border-gray-300 rounded-lg text-[16px] font-medium text-gray-700 hover:bg-gray-50 transition-colors"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="flex-1 py-2 px-4 bg-blue-600 text-white rounded-lg text-[16px] font-medium hover:bg-blue-700 transition-colors"
            >
              Apply
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default DateSelectionModal;
